import Header from './components/Header';
import Hero from './components/Hero';
import Concept from './components/Concept';
import Experience from './components/Experience';
import Flow from './components/Flow';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="w-full min-h-screen">
      <Header />
      <Hero />
      <Concept />
      <Experience />
      <Flow />
      <Contact />
      <Footer />
    </main>
  );
}
